<style lang="scss" scoped>
  .opera-btn-group .advanced-query-form > .el-row {
    display: block;
    .oms-form-row {
      margin-bottom: 10px;
    }
  }
</style>
<template>
  <div class="opera-btn-group " :class="{up:!showSearch}">
    <form onsubmit="return false">
      <div class="opera-icon ">
        <el-row>
          <el-col :span="13">
            <div v-show="!showSearch">
              <el-col :span="6" class="text-right" style="padding-right: 5px">
                货主订单号
              </el-col>
              <el-col :span="16">
                <oms-input placeholder="请输入货主订单号" type="text" v-model.trim="searchCondition.orderNo"></oms-input>
              </el-col>
            </div>
          </el-col>
          <el-col :span="4" v-show="!showSearch">
            <div>
              <oms-form-row label="" :span="6">
                <el-button type="primary" native-type="submit" @click="searchInOrder">查询</el-button>
                <el-button native-type="reset" @click="resetSearchForm">重置</el-button>
              </oms-form-row>
            </div>
          </el-col>
          <el-col :span="!showSearch ? 7 : 24 " class="opera-btn">
            <span class="pull-right switching-icon" @click="showSearch = !showSearch">
            <i class="el-icon-arrow-up"></i>
            <span v-show="showSearch">高级搜索</span>
            <span v-show="!showSearch">高级搜索</span>
           </span>
          </el-col>
        </el-row>
      </div>
    </form>
    <el-form v-show="showSearch" class="advanced-query-form clearfix"
             onsubmit="return false">
      <el-row>
        <el-col :span="8">
          <oms-form-row :span="6" label="货主订单号">
            <oms-input placeholder="请输入货主订单号" type="text" v-model.trim="searchCondition.orderNo"></oms-input>
          </oms-form-row>
        </el-col>
        <el-col :span="8" v-show="$route.meta.role !== 'org'">
          <oms-form-row :span="6" label="货主">
            <org-select :remote-method="queryUpOrgList" placeholder="请输入名称/拼音首字母缩写/系统代码搜索货主"
                        v-model="searchCondition.upstreamOrgId" :list="upOrgList"/>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row :span="6" label="货品主档">
            <goods-select :remote-method="queryDhsGoods" placeholder="请输入名称搜索货品主档"
                          v-model="searchCondition.goodsId" :list="dhsGoodsList"></goods-select>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row label="批号" :span="5">
            <el-select v-model="searchCondition.batchNumberId" filterable clearable remote
                       :remoteMethod="queryDhsBatchNumbers" placeholder="请输入批号名称搜索批号">
              <el-option v-for="item in batchNumberList" :value="item.id" :key="item.id" :label="item.batchNumber">
                {{ item.batchNumber }}
              </el-option>
            </el-select>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row label="业务类型" :span="6">
            <el-select type="text" v-model="searchCondition.bizType" placeholder="请选择业务类型" clearable>
              <el-option :value="item.key" :key="item.key" :label="item.label"
                         v-for="item in bizTypes"></el-option>
            </el-select>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row :span="6" label="来源单位">
            <org-select :remote-method="queryDownList" placeholder="请输入名称/拼音首字母缩写/系统代码搜索来源单位"
                        v-model.trim="searchCondition.downstreamOrgId" :list="downOrgList"/>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row :span="7" label="来源单位订单号">
            <oms-input type="text" v-model="searchCondition.orderThirdNo" placeholder="请输入来源订单号"></oms-input>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row :span="6" label="状态">
            <el-select clearable placeholder="请选择状态" type="text" v-model="searchCondition.status">
              <el-option :key="item.key" :label="item.label" :value="item.key"
                         v-for="item in orderStatus"></el-option>
            </el-select>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row label="业务时间" :span="5">
            <el-col :span="24">
              <el-date-picker
                v-model="completeTimes"
                type="datetimerange"
                placeholder="请选择业务时间">
              </el-date-picker>
            </el-col>
          </oms-form-row>
        </el-col>
        <!--<el-col :span="8">-->
        <!--<oms-form-row label="下单时间" :span="5">-->
        <!--<el-col :span="24">-->
        <!--<el-date-picker-->
        <!--v-model="createdTimes"-->
        <!--type="datetimerange"-->
        <!--placeholder="请选择">-->
        <!--</el-date-picker>-->
        <!--</el-col>-->
        <!--</oms-form-row>-->
        <!--</el-col>-->
        <el-col :span="8">
          <oms-form-row label="" :span="6">
            <el-button class="ml-15" type="primary" native-type="submit" @click="searchInOrder">查询</el-button>
            <el-button native-type="reset" @click="resetSearchForm">重置</el-button>
          </oms-form-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import MethodsMix from '@/mixins/methodsMinix';
  import utils from "@/tools/utils";

  export default {
    props: {
      bizTypes: Array
    },
    mixins: [MethodsMix],
    data() {
      return {
        showSearch: false,
        createdTimes: '',
        completeTimes:'',
        orderStatus: [],
        searchCondition: {
          status: '',
          upstreamOrgId: '',
          goodsId: '',
          batchNumberId: '',
          orderNo: '',
          bizType: '',
          downstreamOrgId: '',
          orderThirdNo: '',
          createStartTime: '',
          createEndTime: '',
          completeStartTime:'',
          completeEndTime:''
        }
      };
    },
    mounted() {
      this.orderStatus=[];
      let orderStatus=utils['inBspOrderType'];
      Object.keys(orderStatus).forEach(key=>{
        let item=orderStatus[key];
        this.orderStatus.push({key:item.status,label:item.title});
      })
    },
    methods: {
      queryDhsBatchNumbers(val) {
        this.queryDhsBatchNumberList(val);
      },
      searchInOrder: function () {// 搜索
        // this.searchCondition.createStartTime = this.$formatAryTime(this.createdTimes, 0, 'YYYY-MM-DD HH:mm:ss');
        // this.searchCondition.createEndTime = this.$formatAryTime(this.createdTimes, 1, 'YYYY-MM-DD HH:mm:ss');
        this.searchCondition.completeStartTime = this.$formatAryTime(this.completeTimes, 0, 'YYYY-MM-DD HH:mm:ss');
        this.searchCondition.completeEndTime = this.$formatAryTime(this.completeTimes, 1, 'YYYY-MM-DD HH:mm:ss');
        this.$emit('search', this.searchCondition);
      },
      resetSearchForm: function () {// 重置表单
        let temp = {
          status: '',
          upstreamOrgId: '',
          goodsId: '',
          batchNumberId: '',
          orderNo: '',
          bizType: '',
          downstreamOrgId: '',
          orderThirdNo: '',
          createStartTime: '',
          createEndTime: '',
          completeStartTime:'',
          completeEndTime:''
        };
        this.createdTimes = '';
        this.completeTimes = '';
        Object.assign(this.searchCondition, temp);
        this.$emit('search', temp);
      }
    }
  };
</script>
